import React from "react";

import {
  BiLogoFacebook,
  BiLogoInstagram,
} from "react-icons/bi";

import { TfiYoutube } from "react-icons/tfi";

const Footer = () => {

  const currentYear = new Date().getFullYear();

  return (

    <footer className="bg-gradient-to-r from-[#4D96FF] via-[#9B5DE5] to-[#FF6B6B] text-white overflow-hidden">

      <div className="max-w-7xl mx-auto px-6 py-12">

        {/* Top Section */}

        <div className="flex flex-col md:flex-row items-center justify-between gap-8">

          {/* Left */}

          <div className="text-center md:text-left">

            <h2 className="text-3xl font-extrabold mb-3">

              📚 Bhavya Publications

            </h2>

            <p className="text-lg opacity-90 max-w-md">

              Making learning fun, colorful and engaging for every child. 🌈

            </p>

          </div>

          {/* Social */}

          <div>

            <h3 className="text-xl font-bold mb-4 text-center">

              Follow Us ✨

            </h3>

            <div className="flex gap-4 justify-center">

              <a
                href="/"

                className="w-12 h-12 bg-white text-[#4D96FF] rounded-full flex items-center justify-center hover:scale-110 transition duration-300 shadow-lg"
              >

                <BiLogoFacebook size={24} />

              </a>

              <a
                href="/"

                className="w-12 h-12 bg-white text-[#FF6B6B] rounded-full flex items-center justify-center hover:scale-110 transition duration-300 shadow-lg"
              >

                <BiLogoInstagram size={24} />

              </a>

              <a
                href="https://www.youtube.com/@Bhavyapublications"

                className="w-12 h-12 bg-white text-[#9B5DE5] rounded-full flex items-center justify-center hover:scale-110 transition duration-300 shadow-lg"
              >

                <TfiYoutube size={20} />

              </a>

            </div>

          </div>

        </div>

        {/* Divider */}

        <div className="border-t border-white/30 my-8"></div>

        {/* Bottom */}

        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-center">

          <p>

            © {currentYear} Bhavya Publications. All Rights Reserved.

          </p>

          <p>

            Designed & Developed with ❤️ by

            <a
              href="/"

              className="ml-2 font-bold hover:text-yellow-200 transition"
            >

              ShivaniFilms

            </a>

          </p>

        </div>

      </div>

    </footer>

  );
};

export default Footer;